<template>
  <div id="content-page" class="content-page">
    <b-container fluid>
      <b-modal id="modal-interactive-user-code" centered @ok="checkPaymentPublic" @hide-header-close="true" no-close-on-backdrop
        no-close-on-esc>
        <template #modal-ok>Entrar</template>
        <template #modal-title>Introduzca el email para procesar el pago</template>
        <b-form-group label="Email: *" label-for="email">
          <b-form-input id="email" v-model="email" type="text"></b-form-input>
        </b-form-group>
        <router-link class="iq-waves-effect pr-4" :to="{ path: '/public/interactive', query: { interactiveId: interactiveId }}">Ya tienes el código de acceso</router-link>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import routes from "../../router/index";

import { StripeCheckout } from "@vue-stripe/vue-stripe";
import { loadStripe } from "@stripe/stripe-js";
import organizationService from "../../services/organization";
import interactiveService from "../../services/interactive";
import utilsService from "../../services/utils";

export default {
  name: "InteractiveRoomPayment",
  mounted() {
    this.$bvModal.show("modal-interactive-user-code");

  },
  data() {
    return {
      interactive: {},
      interactiveId: this.$route.query.interactiveId,
      homeURL: {
        type: Object,
        default: () => ({ name: "public.singin" }),
      },
      file: "",
      defaultAvatarLogo: true,
      fileLogo: "",
      email: "",
      stripe: {
        publicKey: "",
        idSession: "",
      },
    };
  },
  methods: {
    showStripePayment() {
      let self = this;

      this.$awn.asyncBlock(
        interactiveService.payStripe(this.interactiveId, this.email),
        (response) => {
          if (response) {
            self.stripe = response.data;

            let stripeInit = loadStripe(self.stripe.publicKey);
            // wait for the promise to resolve first
            stripeInit.then((stripe) => {
              stripe
                .redirectToCheckout({
                  sessionId: self.stripe.idSession,
                })
                .then(function (result) {
                })
                .catch(function (error) {
                  console.error(error);
                });
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "iprosService.payStripe",
            module: "view-pages-ipros",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: this.$route.query.professionalId, data: data
            })
          });
        },
        " "
      );
    },
    async checkPaymentPublic(evt) {
      evt.preventDefault();
      let self = this;
      this.$awn.asyncBlock(
        interactiveService.checkPaymentPublic(this.interactiveId, this.email),
        (response) => {
          if (response) {
              if(response.data){
              this.$swal({
                  title: "Se ha enviado al correo electronico el código de acceso",
                  text: "Desea acceder a la sessión",
                  type: "success",
                  showCancelButton: false,
                  confirmButtonText: this.$i18n.t(
                    "public.views.Pages.Professional.Contact.Recipes.alert.signature.send.btnGo"
                  ),
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
                }).then((result) => {
                  if (result.value) {
                    routes.push({
                      path: "/public/interactive",
                      query: { interactiveId: this.interactiveId },
                    });
                  }
                });
            }else{
              self.showStripePayment();
            }
          }
        },
        (error) => {
          
        },
        " "
      );
    },
  },
};
</script>
